// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"title_wrapper__ntr2-kb3XEQ0X","content_wrapper":"content_wrapper__T8EOPPVA06+b+","number_block":"number_block__8Qnmhpr6Jbqq-"};